/* eslint-disable react/prop-types */
import React from 'react'
import noop from 'lib/noop'
import classNames from 'classnames'

import {
  AprraisedValue,
  Discount,
  SaleValueText,
  JudicialSaleCard,
} from 'components'

import styles from './ActionValuesContainer.module.scss'

const ActionValuesContainer = ({
  hasPromotion = false,
  isJudicialSale = false,
  juridical,
  mainValue,
  appraisedPrice,
  appraisedLowerThanMain = false,
  appraisedLabel,
  showDiscount = false,
  desagio,
  hideValue = false,
  mainValueLabel,
  callToActionConsiderations = [],
  campaignTotalValue,
  getNameCampaign = noop,
}) => {
  const isAprraisedValue =
    mainValue !== appraisedPrice && !appraisedLowerThanMain

  return (
    <div
      className={classNames(styles.valuesContainer, {
        [styles.activeCampaign]: hasPromotion,
      })}
    >
      <JudicialSaleCard show={isJudicialSale} juridicalData={juridical} />

      <AprraisedValue
        show={isAprraisedValue}
        value={appraisedPrice}
        type="row"
        label={appraisedLabel}
        strike={mainValue !== appraisedPrice}
        isCampaign={hasPromotion}
      />
      <Discount show={showDiscount} percent={desagio} />
      <SaleValueText
        value={hideValue ? null : mainValue}
        saleLabel={mainValueLabel}
        asterisk={!!callToActionConsiderations.length}
        isCampaign={hasPromotion}
      />
      <SaleValueText
        show={!!hasPromotion}
        saleLabel={`Valor ${getNameCampaign()}`}
        value={campaignTotalValue}
        propertyCard
        asterisk
        className={styles.promotionPrice}
      />
    </div>
  )
}

export default React.memo(ActionValuesContainer)
